import styled from 'styled-components';
import { breakpoints, cssfonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${pxToRem(3)};
`;

export const Title = styled.h3`
  ${cssfonts.exbold};
  ${pxToCssFont(20, 26)}
  margin:0;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }
`;

export const Description = styled.span<{ hasIcon?: boolean }>`
  ${pxToCssFont(16, 22)}
  margin-top: ${pxToRem(3)};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(18, 24)}
    ${(props) => (props.hasIcon ? `margin-top: 0;` : '')}
  }
`;

